import React from "react";

import expedia_logo from "../../img/expedia_logo.png";
import booking_logo from "../../img/booking_logo.png";
import stripe_logo from "../../img/stripe_logo.png";
import mercado_pago_logo from "../../img/mercado_pago_logo.png";
import yape_logo from "../../img/yape_logo.png";

const Integraciones = () => {
    return (
        <div className="w-full lg:mt-10 mt-5 mb-10">
            <div className="3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto">
                <div className="text-[#071829] 2xl:text-4xl xl:text-3xl text-2xl font-bold text-center  ">
                    Integraciones
                </div>
                <div className="flex md818:flex-row flex-col justify-center items-center 2xl:gap-28 lg:gap-20 md:gap-16 gap-10 2xl:mt-10 mt-7">
                    <img
                        className="2xl:h-9 lg:h-7 h-6 w-auto"
                        src={expedia_logo}
                        alt="expedia"
                    />
                    <img
                        className="2xl:h-9 lg:h-7 h-6 w-auto"
                        src={booking_logo}
                        alt="booking"
                    />
                    <img
                        className="2xl:h-9 lg:h-7 h-6 w-auto"
                        src={stripe_logo}
                        alt="stripe"
                    />
                    <img
                        className="2xl:h-9 lg:h-7 h-6 w-auto"
                        src={mercado_pago_logo}
                        alt="mercado"
                    />
                    <img
                        className="2xl:h-12 lg:h-10 h-9 w-auto"
                        src={yape_logo}
                        alt="yape"
                    />
                </div>
            </div>
        </div>
    );
};

export default Integraciones;
